import tabView from "../views/tabView";

/**
 * Controls the tab functionality
 * @throws {Error} If tabView is not properly initialized
 */
const controlTab = function () {
  try {
    tabView.render();
  } catch (error) {
    console.error("Error rendering tab view:", error);
    tabView.renderError("Failed to render tab view. Please refresh the page.");
  }
};

/**
 * Initializes the application
 * Sets up event handlers and initial render
 */
const init = function () {
  try {
    // Set up event handlers
    tabView.addHandlerRender(controlTab);
    tabView.addHandlerTabs(controlTab);

    // Initial render
    controlTab();
  } catch (error) {
    console.error("Failed to initialize application:", error);
    tabView.renderError(
      "Failed to initialize application. Please refresh the page."
    );
  }
};

// Initialize the application
document.addEventListener("DOMContentLoaded", init);
